import { ChildFieldsFilterModel } from 'src/app/shared/odata-filter-models/child-fields-filter-model';
import { CustomFieldFilterModel } from 'src/app/shared/odata-filter-models/custom-field-filter-model';
import { RegularFilterModel } from 'src/app/shared/odata-filter-models/regular-filter-model';
import { FilterOperatorType } from './filter-operator-type';
import { FilterNameChangeMapper } from './filter-name-change-mapper';
import { FilterGroup, ODataFilter } from './odata-filter';
import { OPERATORS } from './operators';
import { SelectedFilter } from './selected-filter';
import { ViewContext } from './view-context';
import { SurveyResponsesFilterModel } from 'src/app/shared/odata-filter-models/survey-responses-filter.model';
import { EvaluationAggregateFieldFilterModel } from 'src/app/shared/odata-filter-models/evaluation-aggregate-field-filter.model';
import { SubConditionFilterModel } from 'src/app/shared/odata-filter-models/sub-condition-filter-model';
import { FilterValueTypeChangeMapper } from './filter-value-type-change-mapper';
import { PersonTeamSummaryFilterModel } from 'src/app/shared/odata-filter-models/person-team-summary-filter-model';
import { PeopleFilterFields } from 'src/app/people/models/peopleFilterFields';
import { ComplexFieldsFilterModel } from 'src/app/shared/odata-filter-models/complex-fields-filter-model';
export class SavedFilterBase {
  public selectedFilter: ODataFilter;
  public filterOperatorType: FilterOperatorType;
  public searchValue: any;
  public searchValues: any[];
}

export class SavedFilter extends SavedFilterBase {
  private savedSubFilters: SavedFilterBase[];

  static parseToString(selectedFilter: SelectedFilter) {
    let savedFilter = new SavedFilter();
    savedFilter.selectedFilter = selectedFilter.filter;
    savedFilter.filterOperatorType = selectedFilter.filterOperator.displayOperator;
    savedFilter.searchValue = selectedFilter.searchValue;
    savedFilter.searchValues = selectedFilter.searchValues;
    savedFilter.savedSubFilters = selectedFilter.appliedSubFilters.map((subFilter) => {
      return savedFilter.parseSubFiters(subFilter);
    });
    return JSON.stringify(savedFilter);
  }

  private parseSubFiters(selectedFilter: SelectedFilter): SavedFilterBase {
    let subSavedFilter = new SavedFilterBase();
    subSavedFilter.selectedFilter = selectedFilter.filter;
    subSavedFilter.filterOperatorType = selectedFilter.filterOperator.displayOperator;
    subSavedFilter.searchValue = selectedFilter.searchValue;
    subSavedFilter.searchValues = selectedFilter.searchValues;
    return subSavedFilter;
  }

  static parseToAppliedFilters(data: string[], viewContext: ViewContext) {
    let appledFilters = data.map((d) => {
      let selectedfilter: ODataFilter;
      let savedFilter = JSON.parse(d) as SavedFilter;

      //If we changed any value type in our code, this maps the old value type to the new value type
      savedFilter.selectedFilter.valueType = FilterValueTypeChangeMapper.map(
        savedFilter.selectedFilter.valueType
      );

      if (savedFilter.selectedFilter.filterGroup == FilterGroup.SystemFields) {
        if (
          savedFilter.selectedFilter.targetField == PeopleFilterFields.activeTeamSummary ||
          savedFilter.selectedFilter.targetField == PeopleFilterFields.activeTeamsCount ||
          (savedFilter.selectedFilter.targetField == 'teamSummary' &&
            savedFilter.selectedFilter.childFieldName == PeopleFilterFields.activeTeamsCount)
        ) {
          selectedfilter = new PersonTeamSummaryFilterModel(
            PeopleFilterFields.activeTeamSummary,
            new FilterNameChangeMapper(viewContext).map(savedFilter.selectedFilter.displayName),
            savedFilter.selectedFilter.childFieldName,
            savedFilter.selectedFilter.valueType,
            savedFilter.selectedFilter.values
          );
        } else if (
          savedFilter.selectedFilter.targetField == PeopleFilterFields.allTeamSummary ||
          savedFilter.selectedFilter.targetField == PeopleFilterFields.allTeamsCount ||
          (savedFilter.selectedFilter.targetField == 'teamSummary' &&
            savedFilter.selectedFilter.childFieldName == PeopleFilterFields.allTeamsCount)
        ) {
          selectedfilter = new PersonTeamSummaryFilterModel(
            PeopleFilterFields.allTeamSummary,
            new FilterNameChangeMapper(viewContext).map(savedFilter.selectedFilter.displayName),
            savedFilter.selectedFilter.childFieldName,
            savedFilter.selectedFilter.valueType,
            savedFilter.selectedFilter.values
          );
        } else {
          selectedfilter = new RegularFilterModel(
            new FilterNameChangeMapper(viewContext).map(savedFilter.selectedFilter.displayName),
            savedFilter.selectedFilter.targetField,
            savedFilter.selectedFilter.valueType,
            savedFilter.selectedFilter.values
          );
        }
      } else if (
        [
          FilterGroup.SystemChildFields,
          FilterGroup.PaymentRequirements,
          FilterGroup.RegularRequirements,
        ].includes(savedFilter.selectedFilter.filterGroup)
      ) {
        selectedfilter = new ChildFieldsFilterModel(
          savedFilter.selectedFilter.childFieldName,
          savedFilter.selectedFilter.displayName,
          savedFilter.selectedFilter.targetField,
          savedFilter.selectedFilter.valueType,
          savedFilter.selectedFilter.values,
          savedFilter.selectedFilter.secondFilter,
          savedFilter.selectedFilter.filterGroup
        );
      } else if (savedFilter.selectedFilter.filterGroup == FilterGroup.SurveyQuestions) {
        selectedfilter = new SurveyResponsesFilterModel(
          savedFilter.selectedFilter.filterGroup,
          savedFilter.selectedFilter.displayName,
          savedFilter.selectedFilter.targetField,
          savedFilter.selectedFilter.targetFieldId,
          savedFilter.selectedFilter.valueType,
          savedFilter.selectedFilter.values
        );
      } else if (savedFilter.selectedFilter.filterGroup == FilterGroup.EvaluationQuestions) {
        selectedfilter = new EvaluationAggregateFieldFilterModel(
          savedFilter.selectedFilter.displayName,
          savedFilter.selectedFilter.targetFieldId,
          savedFilter.selectedFilter.valueType,
          savedFilter.selectedFilter.values
        );
      } else if (savedFilter.selectedFilter.filterGroup == FilterGroup.PersonComplexFields) {
        selectedfilter = new ComplexFieldsFilterModel(
          savedFilter.selectedFilter.displayName,
          savedFilter.selectedFilter.targetField,
          savedFilter.selectedFilter.targetFieldId
        );
      } else {
        selectedfilter = new CustomFieldFilterModel(
          savedFilter.selectedFilter.filterGroup,
          savedFilter.selectedFilter.displayName,
          savedFilter.selectedFilter.targetField,
          savedFilter.selectedFilter.targetFieldId,
          savedFilter.selectedFilter.valueType,
          savedFilter.selectedFilter.values
        );
      }

      let appledFilter = new SelectedFilter({
        filter: selectedfilter,
        selectedSubFilters: savedFilter.savedSubFilters
          ? savedFilter.savedSubFilters.map((s) => {
              let sub = new SubConditionFilterModel(
                s.selectedFilter.displayName,
                s.selectedFilter.targetField,
                s.selectedFilter.valueType,
                s.selectedFilter.values,
                s.selectedFilter.targetFieldId
              );
              let subAppledFilter = new SelectedFilter({
                filter: sub,
                filterOperator: OPERATORS[s.selectedFilter.valueType].operators.find(
                  (op) => op.displayOperator == s.filterOperatorType
                ),
                searchValue: s.searchValue,
                searchValues: s.searchValues,
              });
              return subAppledFilter;
            })
          : [],
        filterOperator: OPERATORS[savedFilter.selectedFilter.valueType].operators.find(
          (op) => op.displayOperator == savedFilter.filterOperatorType
        ),
        searchValue: savedFilter.searchValue,
        searchValues: savedFilter.searchValues,
      });
      return appledFilter;
    });
    return appledFilters;
  }
}
